import { render, staticRenderFns } from "./SimpleTransferHeader.vue?vue&type=template&id=5fe8aecc&scoped=true"
import script from "./SimpleTransferHeader.vue?vue&type=script&lang=js"
export * from "./SimpleTransferHeader.vue?vue&type=script&lang=js"
import style0 from "./SimpleTransferHeader.vue?vue&type=style&index=0&id=5fe8aecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe8aecc",
  null
  
)

export default component.exports